var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99951 6.75011C8.99951 5.09325 10.3427 3.75011 11.9995 3.75011C13.6564 3.75011 14.9995 5.09325 14.9995 6.75011H18.0002L18.239 14.8678C18.2812 16.3025 18.3023 17.0199 18.082 17.5868C17.7882 18.3426 17.201 18.9474 16.4541 19.2632C15.8939 19.5001 15.1763 19.5001 13.7409 19.5001H10.2595C8.82422 19.5001 8.10656 19.5001 7.54638 19.2632C6.79947 18.9474 6.21223 18.3426 5.91849 17.5868C5.69819 17.0199 5.71929 16.3025 5.76148 14.8678L6.00024 6.75011H8.99951ZM10.4995 6.75011C10.4995 5.92168 11.1711 5.25011 11.9995 5.25011C12.8279 5.25011 13.4995 5.92168 13.4995 6.75011H10.4995ZM8.99951 9.00011H10.4995V11.2501H8.99951V9.00011ZM13.4995 9.00011H14.9995V11.2501H13.4995V9.00011Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.68e29875f5ea514c9006fd6b8d47184c.svg";
export { ForwardRef as ReactComponent };